export const contactIntro =
  "Use the contact form below to get in touch with me and I'll get back to you asap :)"
